// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayTimeline_timelineContainer__gFXSe {
  margin-bottom: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.DayTimeline_timelineHeader__pdgb2 {
  margin-bottom: 10px;
}

.DayTimeline_timelineHeader__pdgb2 h4 {
  margin: 0;
  font-size: 14px;
  color: #4a9eff;
  font-weight: 500;
}

.DayTimeline_timeline__yR8G6 {
  position: relative;
  height: 60px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  overflow: visible;
}

/* Hour markers */
.DayTimeline_hourMarkers__hO\\+0t {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.DayTimeline_hourMarker__kr8gd {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.DayTimeline_hourLine__evND1 {
  width: 1px;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
}

.DayTimeline_hourLabel__K73et {
  position: absolute;
  top: -18px;
  font-size: 10px;
  color: #888;
  transform: translateX(-50%);
  white-space: nowrap;
}

/* Work blocks */
.DayTimeline_workBlocks__fK9cG {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  height: 44px;
}

.DayTimeline_workBlock__\\+oFQm {
  position: absolute;
  height: 100%;
  background: linear-gradient(135deg, #4a9eff 0%, #357abd 100%);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
  min-width: 2px;
}

.DayTimeline_workBlock__\\+oFQm:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.4);
  z-index: 10;
  border-color: rgba(255, 255, 255, 0.4);
}

.DayTimeline_workBlockContent__mmUf- {
  padding: 4px 6px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.DayTimeline_workBlockTime__WX0Rf {
  font-size: 10px;
  color: white;
  font-weight: 500;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* Tooltip on hover - show ticket title */
.DayTimeline_workBlock__\\+oFQm::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 100;
}

.DayTimeline_workBlock__\\+oFQm:hover::after {
  opacity: 1;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .DayTimeline_timelineContainer__gFXSe {
    padding: 12px;
  }

  .DayTimeline_timeline__yR8G6 {
    height: 50px;
  }

  .DayTimeline_workBlocks__fK9cG {
    height: 36px;
  }

  .DayTimeline_hourLabel__K73et {
    font-size: 9px;
  }

  .DayTimeline_workBlockTime__WX0Rf {
    font-size: 9px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DayTimeline.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,4CAA4C;EAC5C,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".timelineContainer {\r\n  margin-bottom: 20px;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 8px;\r\n  padding: 15px;\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.timelineHeader {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.timelineHeader h4 {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #4a9eff;\r\n  font-weight: 500;\r\n}\r\n\r\n.timeline {\r\n  position: relative;\r\n  height: 60px;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  border-radius: 6px;\r\n  overflow: visible;\r\n}\r\n\r\n/* Hour markers */\r\n.hourMarkers {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.hourMarker {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.hourLine {\r\n  width: 1px;\r\n  height: 100%;\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.hourLabel {\r\n  position: absolute;\r\n  top: -18px;\r\n  font-size: 10px;\r\n  color: #888;\r\n  transform: translateX(-50%);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Work blocks */\r\n.workBlocks {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 0;\r\n  right: 0;\r\n  height: 44px;\r\n}\r\n\r\n.workBlock {\r\n  position: absolute;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #4a9eff 0%, #357abd 100%);\r\n  border-radius: 4px;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  overflow: hidden;\r\n  min-width: 2px;\r\n}\r\n\r\n.workBlock:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.4);\r\n  z-index: 10;\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.workBlockContent {\r\n  padding: 4px 6px;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.workBlockTime {\r\n  font-size: 10px;\r\n  color: white;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n/* Tooltip on hover - show ticket title */\r\n.workBlock::after {\r\n  content: attr(title);\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(-8px);\r\n  background: rgba(0, 0, 0, 0.9);\r\n  color: white;\r\n  padding: 6px 10px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.2s ease;\r\n  z-index: 100;\r\n}\r\n\r\n.workBlock:hover::after {\r\n  opacity: 1;\r\n}\r\n\r\n/* Mobile optimizations */\r\n@media (max-width: 768px) {\r\n  .timelineContainer {\r\n    padding: 12px;\r\n  }\r\n\r\n  .timeline {\r\n    height: 50px;\r\n  }\r\n\r\n  .workBlocks {\r\n    height: 36px;\r\n  }\r\n\r\n  .hourLabel {\r\n    font-size: 9px;\r\n  }\r\n\r\n  .workBlockTime {\r\n    font-size: 9px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineContainer": `DayTimeline_timelineContainer__gFXSe`,
	"timelineHeader": `DayTimeline_timelineHeader__pdgb2`,
	"timeline": `DayTimeline_timeline__yR8G6`,
	"hourMarkers": `DayTimeline_hourMarkers__hO+0t`,
	"hourMarker": `DayTimeline_hourMarker__kr8gd`,
	"hourLine": `DayTimeline_hourLine__evND1`,
	"hourLabel": `DayTimeline_hourLabel__K73et`,
	"workBlocks": `DayTimeline_workBlocks__fK9cG`,
	"workBlock": `DayTimeline_workBlock__+oFQm`,
	"workBlockContent": `DayTimeline_workBlockContent__mmUf-`,
	"workBlockTime": `DayTimeline_workBlockTime__WX0Rf`
};
export default ___CSS_LOADER_EXPORT___;
